import clsx from 'clsx'
import { Col, Grid, Icon, Typography } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useMemo } from 'react'
import Money from '../../Money'
import styles from 'modules/Services/Account/subcomponents/TransactionsList/transactions-list.module.scss'
import { useTranslation } from 'react-i18next'

const TransactionRow = (props) => {
  const { t } = useTranslation(['services'])

  const { id = null, status = null, amount = '', currency = '', direction, className } = props

  const heading = useMemo(
    () => (direction ? t(`transfers_list.direction.${direction}`) : ''),
    [direction],
  )

  const action = useMemo(() => `${id ? `ID: ${id}` : ''}`, [id, status])

  const suffix = useMemo(() => (direction === 'in' ? 'in' : 'out'), [direction])

  return (
    <Grid className={clsx(className, styles['transfers__row'])}>
      <Col
        className={styles['transfers__col']}
        fluid
      >
        <Grid
          flexDirection={'row'}
          gap={16}
          wrap={false}
          flexAlign={'center'}
        >
          <div className={clsx(styles['transfers__badge'], styles['transfers__badge_' + suffix])}>
            <Icon
              size={'sm'}
              name="arrow-line-right"
            />
          </div>

          <Grid
            direction={'column'}
            gap={2}
          >
            <Typography
              variant={'Body-Forms-15'}
              color={'Label-Fifth'}
              className={styles['transfers__heading']}
            >
              {heading}
            </Typography>
            <Typography
              variant={'Body-10'}
              color={'Label-Secondary'}
              className={styles['transfers__action']}
            >
              {action}
            </Typography>
            {status && (
              <Typography
                variant={'Body-10'}
                color={'Label-Secondary'}
                className={styles['transfers__action']}
              >
                {t(`transfers_list.status.${status}`)}
              </Typography>
            )}
          </Grid>
        </Grid>
      </Col>
      <Col
        sm="4"
        className={styles['transfers__col']}
      >
        <Typography
          variant={'Body-25'}
          component={'div'}
          className={clsx(styles['transfers__cost'], styles['transfers__cost_' + suffix])}
        >
          <Money
            number={amount}
            currency={currency}
          />
        </Typography>
      </Col>
    </Grid>
  )
}

export default TransactionRow

TransactionRow.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  currency: PropTypes.string,
  action: PropTypes.string,
  heading: PropTypes.string,
  direction: PropTypes.string,
  status: PropTypes.string,
  id: PropTypes.number,
  created_at: PropTypes.string,
  className: PropTypes.string,
}
